import Newsletter_40Container from "./container/Newsletter_40Container";
export default Newsletter_40Container;
